import { Component, Input, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { RegistrationForm } from '../registration-form';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { ApiRequestService } from '../../shared/api-request-service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { RegistrationResponse } from '../registration-response';
import { PersonalData } from '../../shoppingcart/contact/personal-data';
import { DataDialog } from '../verification/dataDialog';
import { HttpError } from '../../shared/httperror';
import { TranslationService } from '../../translation/translation.service';
import { ShoppingcartService } from '../../shoppingcart/shoppingcart.service';
import { Material } from '../../shoppingcart/material';
import { ForgotPasswordForm } from '../forgot-password-form';
import { ForgotPasswordFormVerification } from '../forgotpasswordverification';
import { MyOrdersRequest } from '../myorders/myordersrequest';
import { PersonalDataResponse } from '../personaldataResponse';
import { LoginData } from '../login-data';
import { ForgotPasswordModification } from '../forgotpasswordmodification';
import { Buffer } from 'buffer';
import { LoadingService } from '../../shoppingcart/loading-spinner/loading.service';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../../toastmessage/toastmessage.service';
import { SigninComponent } from '../signin/signin.component';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs/internal/Observable';

@Component({
    selector: 'lib-forgotpassword',
    templateUrl: './forgotpassword.component.html',
    styleUrls: ['./forgotpassword.component.scss']
})
export class ForgotpasswordComponent {
    selectedAlign: 'start' | 'center' | 'end';
    isForgotPasswordDisplayed = false;
    errorMessage = '';
    forgotPasswordForm?: FormGroup;
    forgotPasswordVerificationForm?: FormGroup;
    forgotPasswordObject?: ForgotPasswordForm = {};
    forgotPasswordVerificationObject?: ForgotPasswordFormVerification = {};
    forgotPasswordModification: ForgotPasswordModification = {};
    passwordsAreNotEqual = '';
    passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])^((?![%]).)*$/;
    @Input() admin = false;
    errorMessagee = '';
    password = 'kiscica86B';

    passwordConfirm: string | undefined = '';

    password2: string | undefined = '';

    token = '1233hjghjghjg34_.!';

    username = 'info@multiverzumkiado.hu';

    loginBaseUrl = '';

    forgotPasswordUrl = '/forgot-password';

    forgotPasswordModificationUrl = '/forgot-password-modification';

    @Input() hasCityAndZipUrl = true;

    getPersonalDataUrl = '/getpersonaldata';

    loggedInPersonalData?: PersonalData;

    isCompany = false;
    isIndividual = true;

    forgotPasswordConfirm: string | undefined = '';

    forgotPassword: string | undefined = '';

    forgotPasswordsAreNotEqual = '';

    material: Material = {};

    oauthToken: LoginData = {};

    errorLoginMessage = '';

    loginUrl = '/oauth2/token';

    verificationUuid = '';

    dataDialogLogin: DataDialog = {};

    isExtraSmall: Observable<BreakpointState>;
    isSmall: Observable<BreakpointState>;
    isMedium: Observable<BreakpointState>;

    constructor(
        @Inject(MAT_DIALOG_DATA) public dataDialog: DataDialog,
        @Inject('AUTH_BACKEND_URL') private _loginUrl: string,
        private _apiRequestService: ApiRequestService,
        private _dialog: MatDialog,
        private _fb: FormBuilder,
        private _http: HttpClient,
        public _router: Router,
        private _loginService: LoginService,
        private _translateService: TranslationService,
        private _shoppingcartService: ShoppingcartService,
        private _loadingService: LoadingService,
        private _toastMessageService: ToastmessageService,
        private _matDialog: MatDialog,
        private readonly breakpointObserver: BreakpointObserver
    ) {
        this.selectedAlign = 'end';
        this.createForgotPasswordForm();
        this.createForgotPasswordVerificationForm();
        this.loginBaseUrl = _loginUrl;
        this.isExtraSmall= this.breakpointObserver.observe(Breakpoints.XSmall);
        this.isSmall= this.breakpointObserver.observe(Breakpoints.Small);
        this.isMedium = this.breakpointObserver.observe(Breakpoints.Medium);
    }


    ngOnInit(): void {
        if (sessionStorage.getItem('token')) {
            sessionStorage.removeItem('token');
        }
    }

    closeDialog() {
        this._dialog.closeAll();
    }

    createForgotPasswordForm() {
        this.forgotPasswordForm = this._fb.group({
            //email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
            password: ['', [Validators.required, Validators.pattern(this.passwordRegex)]],
            passwordConfirm: ['', [Validators.required, Validators.pattern(this.passwordRegex)]]
        });
    }

    createForgotPasswordVerificationForm() {
        this.forgotPasswordVerificationForm = this._fb.group({
            email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]]
        });
    }

    collectForgotPasswordData() {
        this.forgotPasswordObject = {
            //email: this.forgotPasswordForm?.controls['email'].value as string | undefined,
            password: this.forgotPasswordForm?.controls['password'].value as string | undefined
        };

        this.forgotPassword = this.forgotPasswordForm?.controls['password'].value as string | undefined;
        this.forgotPasswordConfirm = this.forgotPasswordForm?.controls['passwordConfirm'].value as string | undefined;

        if (this.forgotPassword === this.forgotPasswordConfirm) {
            return true;
        } else {
            return false;
        }
    }

    collectForgotPasswordVerificationData() {
        this.forgotPasswordVerificationObject = {
            email: this.forgotPasswordVerificationForm?.controls['email'].value as string | undefined
        };
    }

    sendVerificationUuid() {
        this.collectForgotPasswordVerificationData();
        //TODO send this.forgotPasswordObject to backend and save it into db, than navigates back to /login to sign in
        this._apiRequestService
            .sendRequest<RegistrationForm | undefined, RegistrationResponse>(
                this.loginBaseUrl,
                true,
                this.forgotPasswordVerificationObject,
                true,
                this.forgotPasswordUrl
            )
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;
                        //alert(this._translateService.translate(httpError.errorMessage!));
                        this._toastMessageService.displayToastMessage(TOAST_STATE.error,httpError.errorMessage!,MAT_ICON.error);
                        this.dismissError();

                        this._router.navigateByUrl('/');
                    });
                })
            )
            .subscribe((answer: RegistrationResponse) => {
                if (answer.isEmailAddressExist) {
                    this._toastMessageService.displayToastMessage(TOAST_STATE.success,this._translateService.translate('login.verificationForgotPassword'),MAT_ICON.success);
                    this.dismissError();
                    //this._router.navigateByUrl('/verificationforgotpasswordmessage');
                } else {
                    this._toastMessageService.displayToastMessage(TOAST_STATE.warning,answer.message!,MAT_ICON.warning);
                    this.dismissError();
                    //alert(this._translateService.translate(answer?.message!));
                    this._router.navigateByUrl('/');
                }

                this._dialog.closeAll();
            });
    }

    updatePassword() {
        const isEqual = this.collectForgotPasswordData();
        this.forgotPasswordModification = {
            email: this.dataDialog.email,
            password: this.forgotPasswordObject?.password
        };
        if (isEqual) {
            this.collectForgotPasswordData();
            //TODO send this.forgotPasswordObject to backend and save it into db, than navigates back to /login to sign in
            this._apiRequestService
                .sendRequest<RegistrationForm | undefined, RegistrationResponse>(
                    this.loginBaseUrl,
                    true,
                    this.forgotPasswordModification,
                    true,
                    this.forgotPasswordModificationUrl //TODO url más
                )
                .pipe(
                    catchError((error: HttpErrorResponse) => {
                        return throwError(() => {
                            const httpError: HttpError = error.error as HttpError;
                            //alert(this._translateService.translate(httpError.errorMessage!));
                            this._toastMessageService.displayToastMessage(TOAST_STATE.error,httpError.errorMessage!,MAT_ICON.error);
                            this.dismissError();

                            this._router.navigateByUrl('/');
                        });
                    })

                )
                .subscribe((answer: RegistrationResponse) => {
                    //display toast message
                    if(!answer.timeOut) {
                    this._toastMessageService.displayToastMessage(TOAST_STATE.success, answer.message!,MAT_ICON.success);
                    //close toast message
                    this.dismissError();
                    }
                    else if(answer.timeOut) {
                        this._toastMessageService.displayToastMessage(TOAST_STATE.warning, answer.message!,MAT_ICON.warning);
                        //close toast message
                        this.dismissError();
                    }

                    this._dialog.closeAll();
                    this.openLogin(answer.message!);
                });
        } else {
            this.forgotPasswordsAreNotEqual = 'Nem egyeznek a jelszavak!';
        }
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 5000);
    }
    openLogin(message: string) {
        this.dataDialog = {
            message: message
        };
        const popupDialog = this._matDialog.open(SigninComponent, {
            data: this.dataDialog,
            width: 'calc(100% - 50px)',
            maxWidth: '100vw',
            height: '80%'
        });
        const xsmallDialogSubscription = this.isExtraSmall.subscribe((size) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '100%');
            } else {
                popupDialog.updateSize('calc(60% - 50px)', '');
            }
        });

        popupDialog.afterClosed().subscribe(() => {
            xsmallDialogSubscription.unsubscribe();
        });
    }
    login(redirectUrl: string, email: string, password: string) {
        sessionStorage.setItem('clientId', JSON.stringify(email));

        const headers = new HttpHeaders()
            .set('Content-type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Basic ' + Buffer.from(email + ':' + password).toString('base64'));

        const body = 'grant_type=client_credentials&scope=PW_CLIENT';
        this._http
            .post(this.loginBaseUrl + this.loginUrl, body, { headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => (this.errorLoginMessage = 'Nem megfelelő felhasználónév vagy jelszó!'));
                })
            )
            .subscribe((data) => {
                const loggedInUserPersonalDataRequest = {
                    clientId: email!
                };
                //put PersonalData to session to fill the form automatic on /contact
                this._apiRequestService
                    .sendRequest<MyOrdersRequest, PersonalDataResponse>(
                        this.loginBaseUrl,
                        true,
                        loggedInUserPersonalDataRequest,
                        true,
                        this.getPersonalDataUrl
                    )
                    .subscribe((answer) => {
                        sessionStorage.setItem('personalData', JSON.stringify(answer.client));
                        this.oauthToken = data as LoginData;
                        sessionStorage.setItem('token', JSON.stringify(this.oauthToken));
                        this._router.navigateByUrl(redirectUrl);

                        this._dialog.closeAll();
                        if (sessionStorage.getItem('material')) {
                            this._shoppingcartService.addToCart(JSON.parse(sessionStorage.getItem('material') as string) as Material);
                            sessionStorage.removeItem('material');
                        }

                        //TODO call client table to get personalData, request this.loginObject?.email
                    });
            });
    }
}
